import React from 'react';

import { TreeTable } from 'primereact/treetable';
import { IDummyProps } from './types';
import * as meta from '../../meta-data.json';

export const View = (props: IDummyProps) => {
	const {
		rootref,
		testId = 'epo-data-tree',
		stripped,
		bordered,
		size,
		verticalHeaderAlignment = 'middle',
		verticalCellAligment = 'middle',
		...rest
	} = props;
	const _stripped = stripped ? 'p-treetable-striped ' : '';
	const _bordered = bordered ? 'p-treetable-gridlines ' : '';
	const _sizesMap = {
		"mini": "p-treetable-xs ",
		"compact": "p-treetable-sm ",
		"default": "",
		"large": "p-treetable-lg ",
	}
	const _size = _sizesMap[size || 'default'];

	const _headerAlignment = 'p-treetable-header-' + verticalHeaderAlignment
	const _cellAligment = 'p-treetable-cell-' + verticalCellAligment

	return (
		<div
			data-testid={testId}
			data-epo={`epo-data-tree-${meta.version}`}
			{...{ part: `epo-data-tree-${meta.version}` }}
			className={`epo-data-tree-${meta.version}`}
		>
			<TreeTable 
				ref={rootref} 
				{...rest}
				className={`${props.className} ${_stripped} ${_bordered} ${_size} ${_headerAlignment} ${_cellAligment}`}
			></TreeTable>
		</div>
	);
};
